module.exports = __webpack_public_path__ + "img/caravan_logo.ad6f8b7e.png";